// removed by extract-text-webpack-plugin
module.exports = {"nf-iHelp-button":"nf-iHelp-button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/primitives/IHelpButton/IHelpButton.scss
// module id = 4943
// module chunks = 1